import '../../App.less';
import { Layout,Card,Avatar,Comment, Row, Col,ConfigProvider,Table,Modal,Input, Space, AutoComplete,notification, Select,Button } from 'antd';
import React, { Component } from "react";
import es_ES from 'antd/lib/locale/es_ES';
import Highlighter from 'react-highlight-words';
import { SearchOutlined,StarFilled, FileTextOutlined,CheckOutlined,FilePdfOutlined } from '@ant-design/icons';
import moment from 'moment'
import {getAuthors,getAuthorsStr,IP,getComments} from '../components/utils';
import Foot from "../components/Footer" 
import AdminMenu from "../components/AdminMenu"

class AdminJuryProcess extends Component {
  constructor(props){
    super(props)
    const { Option } = Select;
    this.state={
      plays:[],
      authors:[],
      record:null,
      user:'',
      name:'',
      current_jury:undefined,
      showCommentSection:false,
      comment:{},
      jurys_dict:{},
      loaded_table_data:false,
      qualifications_dict:{},
      isBusy:true,
    }
  }
  async componentWillMount() {
    //Genre
    const genre = await fetch(IP + 'api/casa/genero/');
    this.json_g = await genre.json();
    
    this.genres_dict = {};
    this.json_g.forEach(element => {
      this.genres_dict[element.id] = element.nombre
    });

    //Jury
    const response_jury= await fetch(IP + 'api/casa/jurado/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    
    const json_jury = await response_jury.json();
    if(json_jury['detail']){//check if user is authenticated. If not, response has details key
      localStorage.clear()
      window.location.reload(); 
    }
    
    const jury_user = localStorage.getItem("User")
    const current_jury = json_jury.filter(j=>j.usuario.toLowerCase() ==jury_user.toLowerCase())[0]
    const jurys_dict={}
    Object.entries(json_jury).forEach(element => {
      if(this.genres_dict[element[1].genero] != 'Admin' && (this.genres_dict[current_jury.genero] == 'Admin' || element[1].genero == current_jury.genero)  )
        jurys_dict[element[1].id]=element[1]
    });
   
    //Qualifications
    var qual_url = new URL(IP + 'api/casa/calificacion/')
    const qualifications = await fetch(qual_url);
    const json_qualifications = await qualifications.json()
    const qualifications_dict={}
    const final_qualifications_dict={}
    var current_jury_qualifications = {}
    json_qualifications.forEach(element => {
      if(element.jurado == current_jury.id)
        current_jury_qualifications[element.obra] = element
      if(element.jurado.toString() in jurys_dict){
        if(!(element.obra.toString() in qualifications_dict)){
          qualifications_dict[element.obra]={}
          final_qualifications_dict[element.obra]={}
          for(var j in jurys_dict){
            qualifications_dict[element.obra][j]=null
            final_qualifications_dict[element.obra][j]=null
          }
        }
        qualifications_dict[element.obra][element.jurado]= element.puntaje == 2 ? true : false
        final_qualifications_dict[element.obra][element.jurado]= element.puntaje == 3 ? true : false
        if(element.jurado == current_jury.id)
          qualifications_dict[element.obra]['id']=element.id
      }
    });
   
    //Plays
    const response_plays = await fetch(IP + 'api/casa/obra/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json_plays = await response_plays.json();
   
    var data = []
    this.authorsStr = new Set();
    this.auths = new Set();
    this.categories = new Set();
    this.codes = new Set();
    this.titles = new Set();
    this.dates = new Set();
    this.pseudos = new Set();
    this.edits = [];
    
    const Moment = require('moment');
    
    for(var i in json_plays){
      const item = json_plays[i];
      if(!(item.id.toString() in qualifications_dict) && !(item.id.toString() in final_qualifications_dict))
        continue

      if(item.genero != current_jury.genero  && this.genres_dict[current_jury.genero] != 'Admin'){
        continue
      }
      let isPreselected = false
      for(var c in qualifications_dict[item.id]){
        if(qualifications_dict[item.id][c] == true){
          isPreselected = true
          break
        }
      }
      
      if(!isPreselected){
        continue
      }
      var date= new Moment(item.fecha_registro).format('DD-MM-YYYY')
      var author= getAuthors(item.conc)
      var a= getAuthorsStr(item.conc)
      for(var j in a ){
        this.authorsStr.add(a[j])
      }
      
      var authorStr = getAuthorsStr(item.conc).join(", ")
      this.auths.add(author)
      this.categories.add(this.genres_dict[item.genero])
      this.titles.add(item.titulo);
      this.dates.add(date);
      this.edits.push("")
      this.pseudos.add(item.pseudonimo)
      const year = date.split('-')[2]
      this.codes.add(year+'_'+item.genero+'_'+item.id);
      var play = { 
        id : item.id,
        title : item.titulo,
        author: author ,
        authorStr:authorStr,
        date:date,
        pseudo: item.pseudonimo,
        code:year+'_'+item.genero+'_'+item.id,
        conc:item.conc,
        category:this.genres_dict[item.genero],
        categoryObj:{id:item.genero, nombre:this.genres_dict[item.genero] },
        pdf:item.pdf,
    }
   
      for(var j in jurys_dict){
        play[j] = final_qualifications_dict[item.id][j]?<StarFilled style={{color:"#fbb034"}} />: qualifications_dict[item.id][j] ? <CheckOutlined style={{color:"green"}} />:' '
      }
      data.push(play)
    };

   
    this.auths = [...this.auths].map((v)=>{
      return {value:v}
    })
    this.categories =[...this.categories].map((v)=>{
      return {value:v}
    })
    this.codes = [...this.codes].map((v)=>{
      return {value:v}
    })
    this.titles = [...this.titles].map((v)=>{
      return {value:v}
    })
    this.dates = [...this.dates].map((v)=>{
      return {value:v}
    })

    this.pseudos = [...this.pseudos].map((v)=>{
      return {value:v}
    })
    
    this.authorsStr = [...this.authorsStr].map((v)=>{
      return {value:v}
    })
    this.setState({user:jury_user,current_jury:current_jury, name:current_jury.nombre_completo, jurys_dict:jurys_dict, plays: data ,loaded_table_data:true, qualifications_dict:qualifications_dict});
  }
  getAutocomplete = (dataIndex) =>{
    console.log(this.codes)
    if(dataIndex == "code"){
      return this.codes
    }
    
    else if (dataIndex == "title" ) {
        return this.titles
    } 

    else if (dataIndex == "author"){
      return  this.authorsStr
    }

    else if (dataIndex == "category"){
      return this.categories
    }
    else if (dataIndex == "pseudo"){
      return this.pseudos
    }
    
    else{
      return this.dates
    }
  }
  
 
  getChildComments(comment){
    return (
      <Comment
      author={<a>{this.state.jurys_dict[comment.jurado].nombre_completo}</a>}
      avatar={
        <Avatar
          src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[comment.jurado].nombre_completo}&background=random`}
          alt={this.state.jurys_dict[comment.jurado].nombre_completo}
        />
      }
      content={
        <p>
          {comment.texto}
        </p>
      }
      datetime={
          <span>{moment(comment.fecha).format('YYYY-MM-DD HH:mm:ss')}</span>
      }
    >
      {comment.respuestas.map(id => {
          return this.getChildComments(this.state.comment[id])
      })}
      </Comment>
      )
  }
  getColumnSearchProps = (dataIndex,nombre) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <AutoComplete 
            style={{ width: 188, marginBottom: 8, display: 'block' }}
            options={this.getAutocomplete(dataIndex)}
            filterOption={(inputValue,option)=>option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
            onChange={(value)=>{setSelectedKeys(value ? [value] : [])}}
            value={selectedKeys[0]}
            >
              <Input
                ref={node => {
                  this.searchInput = node;
                }}
                placeholder={`Buscar ${nombre}`}
                onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
              />
            </AutoComplete>
            <Space>
              <Button
                type="primary"
                onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Buscar
              </Button>
              <Button onClick={() =>{setSelectedKeys([]); this.handleReset(clearFilters)}} size="small" style={{ width: 90 }}>
                Resetear
              </Button>
    
            </Space>

          </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
          dataIndex!="author"?
           (record[dataIndex]
            ? record[dataIndex].toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())
            : ''):
            (record[dataIndex]? record[dataIndex].some(auth=>auth['name'].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())):'')
       ,
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => this.searchInput.select(), 100);
          }
        },
        render: (text,record,index) =>
           this.state.searchedColumn === dataIndex ? (
             dataIndex !="author"?
            (<div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
            </div>):
            record[dataIndex].map(auth=>
            (<div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={auth['name'] ? auth['name'] : ''}
            />
            </div>))
          ) : (
            <div style={{fontSize:'large', backgroundColor: this.state.current_jury.obras.includes(record.id) ? '#d9d9d9': 'white' }}>
              { text  }
            </div>
          ),
      });
    
      handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        console.log("handle")
        console.log(selectedKeys[0])
        this.setState({
          searchText: selectedKeys[0],
          searchedColumn: dataIndex,
        });
      };
      async openComments(record){
        var comments_dict = await getComments(record ? record:this.state.record.id)
        console.log("come",comments_dict)
        this.setState({showCommentSection:true, currentRecordId:record ? record:this.state.record.id, comment:comments_dict})
      }
      handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });

      };
    
      getDataFromURL = (url) => new Promise((resolve, reject) => {
        setTimeout(() => {
            fetch(url)
                .then(response => response.text())
                .then(data => {
                    resolve(data)
                });
        });
    }, 2000);

    downloadFile=(record)=>{
      var downloadUrl = IP + 'api/casa/file/'+ record.id
      
        fetch(downloadUrl, {
          method: "GET",
          headers: {
            "Content-Type": "application/pdf"
          }
        })
          .then(res => res.blob())
          .then(response => {
            //Create a Blob from the PDF Stream
            console.log(response);
            const blob = new Blob([response], {
              type: "application/pdf"
            });
            const link = document.createElement('a');
            // create a blobURI pointing to our Blob
            link.href = URL.createObjectURL(blob);
            link.download = record.code;
            // some browser needs the anchor to be in the doc
            document.body.append(link);
            link.click();
            link.remove();
            // in case the Blob uses a lot of memory
            setTimeout(() => URL.revokeObjectURL(link.href), 7000);
            //Open the URL on new Window
            // window.open(fileURL);
          })
          .catch(error => {
            console.log(error);
          });
      }
      readFile =  (pdf)=>{
        window.open(pdf)
      };
      
  
      closeComments=()=>{
        this.setState({showCommentSection:false})
      }

  render() {
      const { Content } = Layout;
      const Moment = require('moment');
      const columns = [
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Número</div>,
                    dataIndex: 'code',
                    key: 'code',
                    width:150,
                    ...this.getColumnSearchProps('code','número'),
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Título</div>,
                    dataIndex: 'title',
                    key: 'title',
                    ...this.getColumnSearchProps('title','título'),
                    responsive: ['sm'] 
                  },
                
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Seudónimo</div>,
                    dataIndex: 'pseudo',
                    key: 'pseudo',
                    ...this.getColumnSearchProps('pseudo','seudónimo'),
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Género</div>,
                    dataIndex: 'category',
                    key: 'gecategorynre',
                    ...this.getColumnSearchProps('category','género'),
                    responsive: ['sm'] 
                  },    
                  {
                    dataIndex:"pdf",
                    key:"pdf",
                    align:'center',
                    width:95, 
                    render: (text,record)=> {
                      return {
                        props: {
                          style: { background: "white",fontSize:'large' }
                        },
                        children:  
                       
                       <Button onClick={()=>this.readFile(text)}><FilePdfOutlined/> Leer</Button>
                      }} 
                  },
                  {
                    dataIndex:"id",
                    key:"id",
                    align:'center',
                    width:130 ,
                    render: (text,record)=> {
                      return {
                        props: {
                          style: { background: "white",fontSize:'large',}
                        },
                        children:  
                       <Button onClick={() => this.downloadFile(record)} ><FilePdfOutlined/>  Descargar</Button>
                      }
                  }},
                  {
                    dataIndex:"id",
                    key:"id",
                    align:'center',
                    render: (text,record)=> {
                      return {
                        props: {
                          style: { background:  "white",fontSize:'large',width:173 }
                        },
                        children:  <div> 
                       
                      <Button onClick={() => this.openComments(record.id)} ><FileTextOutlined />  Comentarios</Button></div>
                      }} 
                  },
            ];
            for(var j in this.state.jurys_dict){
                var column = {
                  title: <div style={{fontWeight:'bold', fontSize:'large', position: 'relative',
                  display: 'flex',
                  justifyContent: 'center',
                  alignElements:'center',}}>{this.state.jurys_dict[j].usuario}</div>,
                  dataIndex: j.toString(),
                  key: j.toString(),
                  width:"100px",
                  render: (text,record,index) =>(
                    <div style={{fontSize:'large', backgroundColor: 'white', position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignElements:'center' }}>
                      {text}
                    </div>
                  ),
                  responsive: ['sm'] 
                }
              columns.push(column)
            }
    return (
      <div className="page-container">
      <div className = "content-wrap">
      <ConfigProvider locale={es_ES}>
        <Layout style={{backgroundColor:'white'}}>
          <AdminMenu defaultSelectedKey = {"jury_process"}/>
          <Content>
            <Card>
              <Row justify="center" align="middle">
                <Col span={24}>
                  <Table
                  loading={!this.state.loaded_table_data}
                  scroll={{ x: 1300 }}
                    columns={columns}
                    dataSource= {this.state.plays}
                    pagination={{ position: ["bottomCenter"],}} 
                    tableLayout='auto'
                    size='small'
                    style={{ whiteSpace: 'normal'}}
                  />
                </Col>
              </Row>
            </Card>
            { this.state.showCommentSection && 
              <Modal 
                closable = {false}
                title={ "Comentarios"}
                visible={this.state.showCommentSection} 
                width={580}
                footer={[
                    <Button key="back" onClick={this.closeComments}>
                      Cerrar
                    </Button>,
                ]}
              >
                <Row align="middle" justify="center" >
                  <Col span={24}>
                    {
                      Object.entries(this.state.comment).map(element=>{
                        if (!element[1].comentario_padre){
                          return this.getChildComments(element[1])
                        }
                      })
                    }
                  </Col>
                </Row>
              </Modal>
            }
          </Content>
        </Layout>
      </ConfigProvider>
    </div>
    <Foot admin={true}/>
    </div>
    );
  }
}
export default AdminJuryProcess;


